import React from 'react';
import { Link } from 'react-router-dom';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import { FaShieldAlt, FaUserShield, FaLock, FaHandshake, FaFileAlt, FaMoneyBillWave } from 'react-icons/fa';
import '../Assets/Styles/Pages/policy_page.css';

const Policy_page = () => {
  const policies = [
    {
      icon: <FaShieldAlt />,
      title: "Privacy Policy",
      content: [
        "Welcome to Trillion Stock Research. We understand and respect your privacy, and we are committed to protecting it. In order to provide transparency and clarity on how we collect and use your information, we have created this notice which outlines our online information practices and your options for providing and managing that information.",
        "Protecting your privacy and data is extremely important to us. We take measures to ensure the security and confidentiality of any information shared with us. We will only use personally identifiable information for the purposes to which you have consented. However, we cannot guarantee the security of your information 100%, despite our efforts to protect it. Any information you transmit to us through our online services is done at your own risk.",
        "Please note that you may receive calls related to service promotions, contests, and pools organized by us. Your information, whether public or private, will be held with us only. However, it may be transferred or given to our regulatory authorities and their related organizations, as well as any organizations or individuals with whom we have an interest for any reason, without your consent.",
        "In addition of the services we provide to you, we may also use your personal information such as your mobile number and email address to send you newsletters, surveys, contest information, or updates on any new services that we believe may be beneficial to you. By subscribing to our services, you agree to allow Trillion Stock Research to use your personal information for these purposes.",
        "By submitting the 'Inquiry form' on this website or through any other means, including social media, you are providing your consent to allow us to contact you via phone call, SMS, or WhatsApp on the number provided by you. Even if your mobile number is registered on the National 'Do Not Disturb' registry, you agree to receive communication from us. We appreciate your trust in us and assure you that we will always respect your privacy."
      ]
    },
    {
      icon: <FaUserShield />,
      title: "Terms of Service",
      content: [
        "By using our services, you agree to these terms and conditions.",
        "We reserve the right to modify or terminate services at any time.",
        "Users must be at least 18 years old to use our services.",
        "You are responsible for maintaining the confidentiality of your account.",
        "We are not liable for any investment losses incurred."
      ]
    },
    {
      icon: <FaLock />,
      title: "Security Policy",
      content: [
        "We use industry-standard encryption to protect your data.",
        "Regular security audits are conducted to ensure system safety.",
        "Two-factor authentication is available for enhanced security.",
        "We maintain secure backup systems for your data.",
        "Access to your information is strictly controlled and monitored."
      ]
    },
    {
      icon: <FaHandshake />,
      title: "Investment Policy",
      content: [
        "All investment advice is based on thorough research and analysis.",
        "We maintain transparency in our investment strategies.",
        "Regular portfolio reviews and updates are provided.",
        "Risk management is a key component of our investment approach.",
        "We comply with all SEBI regulations and guidelines."
      ]
    },
    {
      icon: <FaFileAlt />,
      title: "Disclosure Policy",
      content: [
        "We maintain full transparency in our operations.",
        "All fees and charges are clearly disclosed upfront.",
        "Regular updates are provided on portfolio performance.",
        "Any conflicts of interest are disclosed immediately.",
        "We maintain accurate records of all transactions."
      ]
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Refund Policy",
      content: [
        "All sales are final, and we do not offer refunds for the paid period of services already availed by the client.",
        "As per SEBI guidelines, refunds shall only be issued for the unused portion of the subscription period on a pro-rata basis.",
        "Refunds will not be provided for the period of services already availed, irrespective of client satisfaction.",
        "Trading/Investment in Securities Markets are always subjected to Market Risk.",
        "Trillion Stock Research shall not be liable for any trade losses incurred based on the research provided."
      ],
      link: "/refund"
    }
  ];

  return (
    <>
      <div className="policy-page">
        <AboutNav />
        <SEBISlider />
        
        <section className="policy-hero">
          <div className="policy-hero-content">
            <h1>Our Policies</h1>
            <p>Transparency and trust are the cornerstones of our service</p>
          </div>
        </section>

        <section className="sebi-warning">
          <div className="warning-container">
            <div className="warning-icon">⚠️</div>
            <div className="warning-content">
              <p>"Investment in securities market are subject to market risks. Read all the related documents carefully before investing."</p>
            </div>
          </div>
        </section>

        <section className="policy-container">
          <div className="policy-intro">
            <h2>Comprehensive Policy Framework</h2>
            <p>At Trillion Stock Research, we maintain strict policies to ensure the highest standards of service, security, and compliance. Our policies are designed to protect your interests and maintain transparency in all our operations.</p>
          </div>

          <div className="policy-grid">
            {policies.map((policy, index) => (
              <div key={index} className={`policy-card ${policy.link ? 'clickable' : ''}`}>
                {policy.link ? (
                  <Link to={policy.link} className="policy-card-link">
                    <div className="policy-icon">
                      {policy.icon}
                    </div>
                    <h3>{policy.title}</h3>
                    <ul className="policy-list">
                      {policy.content.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                    <div className="policy-link-indicator">
                      Click to view full policy →
                    </div>
                  </Link>
                ) : (
                  <>
                    <div className="policy-icon">
                      {policy.icon}
                    </div>
                    <h3>{policy.title}</h3>
                    <ul className="policy-list">
                      {policy.content.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            ))}
          </div>

          <div className="policy-update">
            <h2>Last Updated</h2>
            <p>Our policies are regularly reviewed and updated to ensure compliance with the latest regulations and best practices. The last update was made on March 15, 2024.</p>
          </div>
        </section>

        <section className="policy-cta">
          <div className="cta-content">
            <h2>Have Questions About Our Policies?</h2>
            <p>Our team is here to help you understand our policies and procedures.</p>
            <button className="cta-button">Contact Support</button>
          </div>
        </section>

        <Footer />
        <ISOCertificateButton />
      </div>
    </>
  );
};

export default Policy_page;
